import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SectionAttributes, Section, AnyInnerSection } from '../../../app/types/section';
import { SectionComponent } from '../../components/section/section.component';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

interface FillerAttributes extends SectionAttributes {
  forceMarginBottom: boolean;
}

type FillerEditorIds = [
  'numColumns',
  'forceMarginBottom',
]

export type FillerSection = Section<FillerAttributes, FillerEditorIds, 'filler'>;

export function isFillerSection(section: AnyInnerSection): section is FillerSection {
  return section.component === 'filler';
}

@Component({
    selector: 'app-filler',
    styleUrls: ['./filler.component.scss'],
    templateUrl: './filler.component.html',
    imports: [FsButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      '[class.forceMarginBottom]': 'forceMarginBottom',
    },
})
export class FillerComponent extends SectionComponent<FillerSection> implements OnInit {
  protected forceMarginBottom = false;

  public override ngOnInit() {
    super.ngOnInit();

    this.forceMarginBottom = this.attributes.forceMarginBottom;
  }
}
